import { http } from '@/public/utils/http'

/**
 * 获取模板列表
 * @param {Array} genericIds - 模板ID列表
 * @returns {Promise} - 模板列表
 */
export function getTemplateListByIds(genericIds) {
  return http('system.defineSearchFieldTemplate.list', { genericIds })
}

/**
 * 保存模板
 * @param {Object} data - 模板对象
 * @returns {Promise} - 保存结果
 */
export function saveTemplate(data) {
  return http('system.defineSearchFieldTemplate.batchSaveOrUpdate', data)
}

/**
 * 删除模板
 * @param {String} batchId - 模板ID
 * @returns {Promise} - 删除结果
 */
export function deleteTemplate(batchId) {
  return http('system.defineSearchFieldTemplate.delete', { batchId })
}

/**
 * 编辑模板
 * @param {Object} template - 模板对象
 * @returns {Promise} - 编辑结果
 */
export function editTemplate(data) {
  return http('system.defineSearchFieldTemplate.updateFieldTemplate', data)
}

/**
 * 保存用户配置
 * @param {Object} data - 用户配置对象
 * @returns {Promise} - 保存结果
 */
export function saveUserConfig(data) {
  return http('system.genericSearch.field.saveOrUpdate', data)
}

/**
 * 重置用户配置
 * @param {Object} data - 用户配置对象
 * @returns {Promise} - 保存结果
 */
export function resetUserConfig(data) {
  return http('system.genericSearch.field.reset', data)
}



// WEBPACK FOOTER //
// ./src/public/components/kye-field-settings/data/http-data.js